module.exports = __webpack_public_path__ + "assets/images/project/stylised-images/polling-day-polls-open.jpg?v=2ece23d3";